import { render, staticRenderFns } from "./FontPicker.vue?vue&type=template&id=a4bd941c&"
import script from "./FontPicker.vue?vue&type=script&lang=js&"
export * from "./FontPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports